import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import "./DashboardPage.css";

const DashboardPage = () => {
  const [visitData, setVisitData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [language, setLanguage] = useState(localStorage.getItem("language") || "pt");

  const getApiUrl = () => {
    return "/api"; // Standardized API base path
  };

  const API_URL = getApiUrl();

  useEffect(() => {
    axios
      .get(`${API_URL}/dashboard/most-visited-pages`)
      .then((response) => {
        setVisitData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching visit data:", error);
        setLoading(false);
      });
  }, []);

  React.useEffect(() => {
    const handleLanguageChange = () => {
      setLanguage(localStorage.getItem("language") || "pt");
    };
    window.addEventListener("languageChange", handleLanguageChange);
    return () => window.removeEventListener("languageChange", handleLanguageChange);
  }, []);

  return (
    <div className="dashboard">
      <h1>Page Visit Analytics</h1>
      {loading ? (
        <p>Loading data...</p>
      ) : (
        <div className="chart-container" style={{ width: "100%", height: "700px" }}>
          <ResponsiveContainer>
            <BarChart
              data={visitData}
              margin={{ top: 20, right: 30, left: 20, bottom: 100 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              {/* Note the capital N in "Name" */}
              <XAxis 
                dataKey="Name" 
                angle={-45} 
                textAnchor="end" 
                dy={10} 
                interval={0} // show all labels
              />
              <YAxis />
              <Tooltip />
              {/* Note the capital V in "Visits" if needed */}
              <Bar dataKey="Visits" fill="rgba(225, 200, 9, 0.6)" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};

export default DashboardPage;
